// /publicCenters DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정. 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리.

import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { StatusChip } from "components/list";
import { IpublicCenter } from "../interfaces";
import { kindOfMeta, statusMeta, resolveStatusMeta } from "./publicCentersStatus";

export const publicCentersColumns: GridColDef<IpublicCenter>[] = [
  { field: "id", headerName: "ID", type: "number", width: 84, minWidth: 72, align: "center", headerAlign: "center" },
  // 이름: 약 50자까지 노출 후 ellipsis (15px 폰트 실측 50자 ≈ 570px + 좌우 패딩 20px)
  {
    field: "name",
    headerName: "이름",
    width: 600,
    minWidth: 600,
  },
  {
    field: "kindOf",
    headerName: "종류",
    width: 100,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      // 매핑에 없는 값은 "기타"로 표시 (기존 동작 유지)
      const meta =
        kindOfMeta[params.value as string] ?? { label: "기타", color: "default" as const };
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  // 주소: 약 20자까지 노출 후 ellipsis (15px 폰트 실측 20자 ≈ 235px + 좌우 패딩 20px)
  { field: "address", headerName: "주소", type: "string", width: 260, minWidth: 260 },
  { field: "tel", headerName: "전화번호", type: "string", width: 130, minWidth: 110 },
  { field: "sido", headerName: "시도", type: "string", width: 100, minWidth: 88 },
  { field: "sigungu", headerName: "시군구", type: "string", width: 110, minWidth: 90 },
  { field: "estType", headerName: "유형", type: "string", width: 110, minWidth: 90 },
  {
    field: "status",
    headerName: "상태",
    width: 96,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveStatusMeta(statusMeta, params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  { field: "updatedDate", headerName: "수정일", type: "string", width: 236, minWidth: 190, align: "center", headerAlign: "center" },
];
